import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ArticleClient } from 'api/clients/ArticleClient'
import { Layer } from 'types'
import { layersKeys } from './layersKeys'
import { useArticlePassword } from 'hooks/useArticlePassword'
import { useRootStore } from 'stores/RootStore'
import { CloseReviewActionConfig } from 'stores/Workflows/Types'

interface Props {
  articleKey: string
  id: string
}

export const useDeleteLayer = ({ articleKey, id }: Props) => {
  const queryClient = useQueryClient()
  const rootStore = useRootStore()
  const password = useArticlePassword(articleKey)
  return useMutation<{}, unknown, { payload?: Partial<CloseReviewActionConfig>; onDelete?: () => void }>(
    layersKeys.delete(id),
    async ({ payload }) => {
      const response = await ArticleClient.deleteLayer(articleKey, id, payload)
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return response.data
    },
    {
      onSuccess: async (_, { onDelete }) => {
        onDelete?.()
        if (rootStore.docStore?.lastActiveLayerId === id) {
          rootStore.docStore?.setLastActiveLayerId(undefined)
        }
        queryClient.setQueryData<{ layers: Layer[] } | undefined>(layersKeys.list(articleKey, { password }), (data) => {
          if (!data) {
            return
          }
          const { layers: oldLayers } = data
          return {
            layers: oldLayers.filter((layer: Layer) => layer.id !== id),
          }
        })
      },
    },
  )
}
